// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createMCPFromIntegrationRequestToJson, deleteFunctionRequestToJson, deleteMCPRequestToJson, getFunctionRequestToJson, getFunctionResponseFromJson, getMultiFunctionRequestToJson, getMultiFunctionResponseFromJson, listFunctionRequestToJson, listFunctionResponseFromJson, listMCPToolsRequestToJson, listMCPToolsResponseFromJson, listMCPsRequestToJson, listMCPsResponseFromJson, serializeFunctionRequestToJson, serializeFunctionResponseFromJson, serializeMCPRequestToJson, serializeMCPResponseFromJson, upsertFunctionRequestToJson, upsertMCPRequestToJson, validateFunctionsRequestToJson, validateFunctionsResponseFromJson, validateMCPsRequestToJson, validateMCPsResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function upsert(request) {
    await fetchRpc('ai_assistants.v1alpha1.FunctionService/Upsert', upsertFunctionRequestToJson(request));
}
export function upsert$(request, options) {
    return defer(() => upsertWithTransport$(getGlobalTransport(), request, options));
}
export function upsertWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/Upsert', upsertFunctionRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function get(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.FunctionService/Get', getFunctionRequestToJson(request));
    return getFunctionResponseFromJson(raw);
}
export function get$(request, options) {
    return defer(() => getWithTransport$(getGlobalTransport(), request, options));
}
export function getWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/Get', getFunctionRequestToJson(request), options)
        .pipe(map(resp => getFunctionResponseFromJson(resp)));
}
export async function getMulti(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.FunctionService/GetMulti', getMultiFunctionRequestToJson(request));
    return getMultiFunctionResponseFromJson(raw);
}
export function getMulti$(request, options) {
    return defer(() => getMultiWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/GetMulti', getMultiFunctionRequestToJson(request), options)
        .pipe(map(resp => getMultiFunctionResponseFromJson(resp)));
}
export async function list(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.FunctionService/List', listFunctionRequestToJson(request));
    return listFunctionResponseFromJson(raw);
}
export function list$(request, options) {
    return defer(() => listWithTransport$(getGlobalTransport(), request, options));
}
export function listWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/List', listFunctionRequestToJson(request), options)
        .pipe(map(resp => listFunctionResponseFromJson(resp)));
}
export async function delete_(request) {
    await fetchRpc('ai_assistants.v1alpha1.FunctionService/Delete', deleteFunctionRequestToJson(request));
}
export function delete_$(request, options) {
    return defer(() => delete_WithTransport$(getGlobalTransport(), request, options));
}
export function delete_WithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/Delete', deleteFunctionRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listMCPTools(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.FunctionService/ListMCPTools', listMCPToolsRequestToJson(request));
    return listMCPToolsResponseFromJson(raw);
}
export function listMCPTools$(request, options) {
    return defer(() => listMCPToolsWithTransport$(getGlobalTransport(), request, options));
}
export function listMCPToolsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/ListMCPTools', listMCPToolsRequestToJson(request), options)
        .pipe(map(resp => listMCPToolsResponseFromJson(resp)));
}
export async function upsertMCP(request) {
    await fetchRpc('ai_assistants.v1alpha1.FunctionService/UpsertMCP', upsertMCPRequestToJson(request));
}
export function upsertMCP$(request, options) {
    return defer(() => upsertMCPWithTransport$(getGlobalTransport(), request, options));
}
export function upsertMCPWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/UpsertMCP', upsertMCPRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listMCPs(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.FunctionService/ListMCPs', listMCPsRequestToJson(request));
    return listMCPsResponseFromJson(raw);
}
export function listMCPs$(request, options) {
    return defer(() => listMCPsWithTransport$(getGlobalTransport(), request, options));
}
export function listMCPsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/ListMCPs', listMCPsRequestToJson(request), options)
        .pipe(map(resp => listMCPsResponseFromJson(resp)));
}
export async function deleteMCP(request) {
    await fetchRpc('ai_assistants.v1alpha1.FunctionService/DeleteMCP', deleteMCPRequestToJson(request));
}
export function deleteMCP$(request, options) {
    return defer(() => deleteMCPWithTransport$(getGlobalTransport(), request, options));
}
export function deleteMCPWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/DeleteMCP', deleteMCPRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function createMCPFromIntegration(request) {
    await fetchRpc('ai_assistants.v1alpha1.FunctionService/CreateMCPFromIntegration', createMCPFromIntegrationRequestToJson(request));
}
export function createMCPFromIntegration$(request, options) {
    return defer(() => createMCPFromIntegrationWithTransport$(getGlobalTransport(), request, options));
}
export function createMCPFromIntegrationWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/CreateMCPFromIntegration', createMCPFromIntegrationRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function validateFunctions(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.FunctionService/ValidateFunctions', validateFunctionsRequestToJson(request));
    return validateFunctionsResponseFromJson(raw);
}
export function validateFunctions$(request, options) {
    return defer(() => validateFunctionsWithTransport$(getGlobalTransport(), request, options));
}
export function validateFunctionsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/ValidateFunctions', validateFunctionsRequestToJson(request), options)
        .pipe(map(resp => validateFunctionsResponseFromJson(resp)));
}
export async function validateMCPs(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.FunctionService/ValidateMCPs', validateMCPsRequestToJson(request));
    return validateMCPsResponseFromJson(raw);
}
export function validateMCPs$(request, options) {
    return defer(() => validateMCPsWithTransport$(getGlobalTransport(), request, options));
}
export function validateMCPsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/ValidateMCPs', validateMCPsRequestToJson(request), options)
        .pipe(map(resp => validateMCPsResponseFromJson(resp)));
}
export async function serializeFunction(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.FunctionService/SerializeFunction', serializeFunctionRequestToJson(request));
    return serializeFunctionResponseFromJson(raw);
}
export function serializeFunction$(request, options) {
    return defer(() => serializeFunctionWithTransport$(getGlobalTransport(), request, options));
}
export function serializeFunctionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/SerializeFunction', serializeFunctionRequestToJson(request), options)
        .pipe(map(resp => serializeFunctionResponseFromJson(resp)));
}
export async function serializeMCP(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.FunctionService/SerializeMCP', serializeMCPRequestToJson(request));
    return serializeMCPResponseFromJson(raw);
}
export function serializeMCP$(request, options) {
    return defer(() => serializeMCPWithTransport$(getGlobalTransport(), request, options));
}
export function serializeMCPWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.FunctionService/SerializeMCP', serializeMCPRequestToJson(request), options)
        .pipe(map(resp => serializeMCPResponseFromJson(resp)));
}
